"use client"

import * as React from "react"
import { format } from "date-fns"
import { CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"

import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Calendar } from "./calendar"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "./popover"
import { vi } from "date-fns/locale"

type DatePickerWithRangeProps = {
    date: DateRange | undefined;
    setDate: (date: DateRange | undefined) => void;
    disabled?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export function DatePickerWithRange({
    className,
    date,
    setDate,
    disabled
}: DatePickerWithRangeProps) {
    // const [date, setDate] = React.useState<DateRange | undefined>({
    //     from: new Date(2022, 0, 20),
    //     to: addDays(new Date(2022, 0, 20), 20),
    // })

    return (
        <div className={cn("grid gap-2 bg-white", className)}>
            <Popover>
                <PopoverTrigger asChild>
                    <Button
                        id="date"
                        variant={"outline"}
                        className={cn(
                            "w-[300px] justify-start text-left font-normal",
                            !date && "text-muted-foreground"
                        )}
                        disabled={disabled}
                    >
                        <CalendarIcon />
                        {date?.from ? (
                            date.to ? (
                                <>
                                    {format(date.from, "dd/MM/yyyy", { locale: vi })} -{" "}
                                    {format(date.to, "dd/MM/yyyy", { locale: vi })}
                                </>
                            ) : (
                                format(date.from, "dd/MM/yyyy", { locale: vi })
                            )
                        ) : (
                            <span>Pick a date</span>
                        )}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                        className="bg-white"
                        initialFocus
                        mode="range"
                        defaultMonth={date?.from}
                        selected={date}
                        onSelect={setDate}
                        numberOfMonths={2}
                        locale={vi}
                        modifiersClassNames={{
                            range_start: "bg-black text-white",
                            range_end: "bg-black text-white",
                            today: "bg-blue-500 text-white",
                            selected: "bg-gray-400 text-white",
                        }}
                    />
                </PopoverContent>
            </Popover>
        </div>
    )
}
